module.exports = __webpack_public_path__ + "img/member.2a39fa18.png";